import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { VolunteerService } from "../services/volunteer.service";
import { VolunteerOpportunity } from "../models/volunteer-registration.model";
import { LocalstorageService } from "../services/localstorage.service";
import { VolunteerEventDetailVM } from "../models/volunteer-opportunity.model";

@Component({
  selector: "app-event-opportunity",
  templateUrl: "./volunteer-event.component.html",
  styleUrls: ["./volunteer-event.component.css"],
})
export class VolunteerEventComponent implements OnInit {
  events: VolunteerEventDetailVM[];
  volunteerInNoParticipateList: boolean;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private volunteerService: VolunteerService,
    private localstorageService: LocalstorageService
  ) {}

  ngOnInit() {
    let authDetails = this.localstorageService.getAuth();

    let startDates = [];
    let endDates = [];

    this.volunteerService.getVolunteerEvents(authDetails.employeeInfo.corpId).subscribe((responseData) => {
      this.events = responseData;
      if (responseData.length > 0) {
        this.volunteerInNoParticipateList = responseData[0].volunteerInNoParticipateList;
      }
    });
  }

  moveToActivitiesPage(eventId) {
    this.router.navigateByUrl("volunteer-activities/" + eventId);
  }

  onDescriptionLinkEvent(event) {
    event.stopPropagation();
 }

  onMyEventClicked() {
    this.router.navigate(['volunteer-calendar']);
  }

}
